import { UploadComponent } from '../../csv-importer/csv-upload-wizard';
import { CONTEXT_TYPE } from '../use-upload-context-factory';
import { UploadSynonymsProvider } from './provider';

export function SynonymsUploadWizard() {
  return (
    <UploadSynonymsProvider>
      <UploadComponent contextType={CONTEXT_TYPE.SYNONYMS} />
    </UploadSynonymsProvider>
  );
}
